module.exports = __webpack_public_path__ + "img/empty_state_jobs.be2f5e71.svg";